<div class="flex items-center gap-3">
  <!--div class="relative cursor-pointer opacity-70 hover:opacity-100 transition-opacity">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 448 512"
      class="fill-current"
    >
      <path
        d="M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v144L31.9 396.1C21.4 406.6 28.8 424 43.8 424H404.2c15 0 22.4-17.4 11.9-27.9L384 352V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm0 480c-35.3 0-64-28.7-64-64H288c0 35.3-28.7 64-64 64z"
      />
    </svg>
    <span class="absolute -top-1 -right-1 flex h-3 w-3">
      <span
        class="relative inline-flex rounded-full h-3 w-3 bg-red-500 border border-white"
      ></span>
    </span>
  </div>

  <div class="w-px h-4 bg-border/60"></div-->

  <div
    class="flex items-center cursor-pointer hover:bg-hover rounded-md transition-colors px-1"
    #userMenuOrigin
    (click)="isUserMenuOpen = !isUserMenuOpen"
  >
    <div class="relative flex items-center justify-center">
      <div class="mt-0 text-right px-1.5 flex flex-col h-[32px]">
        <p class="text-sm font-medium whitespace-nowrap">
          {{ authenticationContext()?.userName }}
        </p>
        <p class="text-[10px] text-muted-foreground whitespace-nowrap">
          {{ authenticationContext()?.userFullName }}
        </p>
      </div>
      <div
        class="h-[32px] w-[32px] rounded-full bg-primary text-white flex items-center justify-center text-xs font-bold"
      >
        {{ initials() }}
      </div>
      <span
        class="absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full bg-green-500 ring-2 ring-white"
      ></span>
    </div>
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="userMenuOrigin"
  [cdkConnectedOverlayOpen]="isUserMenuOpen"
  [cdkConnectedOverlayPositions]="[
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 },
  ]"
  (overlayOutsideClick)="isUserMenuOpen = false"
>
  <div class="bg-surface rounded-lg shadow-lg w-52 flex flex-col gap-1 p-1 text-sm">
    <!--p style="font-size: 0.5rem">{{ appName() }} v{{ appVersion() }}</p-->
    <div
      (click)="toggleNightMode(); $event.stopPropagation()"
      class="flex items-center justify-between hover:bg-hover rounded-md p-2 cursor-pointer transition-colors"
    >
      <div class="flex items-center gap-2">
        <soft-icon name="fa-regular fa-moon"></soft-icon>
        <span>Nachtmodus</span>
      </div>

      <div
        class="w-8 h-4 flex items-center rounded-full p-1 duration-300 ease-in-out"
        [class.bg-primary]="isDarkMode()"
        [class.bg-gray-300]="!isDarkMode()"
      >
        <div
          class="bg-white w-3 h-3 rounded-full shadow-md transform duration-300 ease-in-out"
          [class.translate-x-3]="isDarkMode()"
        ></div>
      </div>
    </div>

    <button
      class="flex items-center hover:bg-hover rounded-md p-2 gap-2 cursor-pointer transition-colors w-full text-left"
      (click)="goToSettingsPage()"
    >
      <soft-icon name="fa-regular fa-gear"></soft-icon>
      Einstellungen
    </button>
    <div class="h-px bg-border"></div>

    <button
      (click)="logout()"
      class="flex items-center hover:text-danger hover:bg-hover rounded-md p-2 gap-2 cursor-pointer transition-colors w-full text-left"
    >
      <soft-icon name="fa-regular fa-arrow-right-from-bracket"></soft-icon>
      Abmelden
    </button>
  </div>
</ng-template>
